export default __webpack_public_path__ + "static/media/header-people.d097991f.svg";